import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {TranslateModule, TranslateService} from '@ngx-translate/core';

import {
  AccountingManagementGuard,
} from './accounting-management-auth-guard/accounting-management-guard';
import {
  AccountingMappingManagementComponent
} from './accounting-management/accounting-mapping-management/accounting-mapping-management.component';
import {RegulationTreeComponent} from './regulation-tree/regulation-tree.component';
import {RegulationTreeService} from './regulation-tree/regulation-tree.service';

import {AccountingModule} from '../shared/accounting/accounting.module';
import {AccountingService} from '../shared/accounting/accounting.service';
import {AccountingMappingComponent} from '../shared/accounting/accouting-mapping/accounting-mapping.component';
import {AuthenticationGuard} from '../shared/authentication';
import {ModalModule} from '../shared/modal/modal.module';
import {TreeDiagramModule} from '../shared/tree-diagram/tree-diagram.module';
import {UiModule} from '../shared/ui/ui.module';

const routes: Routes = [
  {
    path: 'regulation',
    component: RegulationTreeComponent,
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'repository',
    loadChildren: () => import('../+organizations/organizations.module').then(m => m.OrganizationsModule),
    canActivate: [AuthenticationGuard]
  },
  {
    path: 'accounting',
    component: AccountingMappingManagementComponent,
    canActivate: [AuthenticationGuard, AccountingManagementGuard]
  },
  {
    path: 'accounting/rules/:accountingPlanId',
    component: AccountingMappingComponent,
    canActivate: [AuthenticationGuard, AccountingManagementGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TreeDiagramModule,
    UiModule,
    TranslateModule,
    RouterModule.forChild(routes),
    AccountingModule,
    ModalModule
  ],
  declarations: [
    RegulationTreeComponent,
    AccountingMappingManagementComponent,
    AccountingMappingManagementComponent
  ],
  exports: [],
  providers: [
    RegulationTreeService,
    AccountingService,
    TranslateService
  ]
})

export class ConfigurationModule {
}
